import { QrCode } from './QrCode'
import { CLINIC, bookingUrl, publicBaseUrl, WHATSAPP_URL } from '../../config/clinic'

/**
 * Pie común de todos los impresos de Cima Sport (H5).
 *
 * Lleva dos cosas distintas y ambas a propósito:
 *  1. **Verificación**: código + QR que abre la página pública de verificación,
 *     para que quien reciba el papel (farmacia, empresa, otro centro) pueda
 *     comprobar que es auténtico sin llamar por teléfono.
 *  2. **Reagendamiento**: web, WhatsApp y un QR a la página de agenda. Es el
 *     patrón del HIS de referencia — marketing embebido en cada documento
 *     clínico — y no cuesta nada: el papel ya está en manos del paciente.
 *
 * TODO-NEGOCIO: los datos de contacto son placeholders (ver config/clinic.ts).
 */

/** Ruta pública de verificación según el tipo de documento. */
const VERIFY_PATH: Record<'clinical-order' | 'certificate', string> = {
  'clinical-order': '/verificar-documento?codigo=',
  certificate: '/verificar?codigo=',
}

export function DocumentIdentityFooter({
  verificationCode,
  kind,
}: {
  verificationCode?: string | null
  kind: 'clinical-order' | 'certificate'
}) {
  const verifyUrl = verificationCode ? `${publicBaseUrl()}${VERIFY_PATH[kind]}${verificationCode}` : null

  return (
    <footer className="mt-6 grid gap-4 border-t border-steel-200 pt-4 text-xs text-steel-600 sm:grid-cols-2">
      {verifyUrl && (
        <div className="flex items-start gap-3">
          <QrCode value={verifyUrl} size={76} />
          <div className="min-w-0">
            <p className="font-semibold text-ink">Verificación del documento</p>
            <p className="font-mono">{verificationCode}</p>
            <p className="break-all">{verifyUrl}</p>
            <p className="mt-1">Escanea el código para comprobar su autenticidad en línea.</p>
          </div>
        </div>
      )}

      <div className="flex items-start gap-3 sm:justify-end">
        <QrCode value={bookingUrl()} size={76} />
        <div className="min-w-0">
          <p className="font-semibold text-ink">Agenda tu próxima hora</p>
          <p className="break-all">{bookingUrl()}</p>
          {/* TODO-NEGOCIO: teléfono y WhatsApp definitivos. */}
          <p>WhatsApp {CLINIC.phone}</p>
          <p className="break-all">{WHATSAPP_URL.split('?')[0]}</p>
          <p className="mt-1">{CLINIC.address}</p>
        </div>
      </div>
    </footer>
  )
}
